import { PropTypes } from 'react';

// TODO: to revist the structure after the service
const TOPIC_FAQ_ITEM = {
  id: PropTypes.string,
  title: PropTypes.string,
  solutionId: PropTypes.string,
  solutionClass: PropTypes.string,
  topicId: PropTypes.string,
};

const TOPIC = {
  id: PropTypes.string,
  name: PropTypes.string,
  faqList: PropTypes.arrayOf(PropTypes.shape(TOPIC_FAQ_ITEM)),
};

const ARTICLE_LIST = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  articleList: PropTypes.arrayOf(PropTypes.shape(TOPIC)),
};

const COMMUNITY = {
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  results: PropTypes.arrayOf(PropTypes.shape({
    articleTitle: PropTypes.string,
    articleId: PropTypes.number,
    views: PropTypes.number,
    link: PropTypes.string,
  })),
};

module.exports = {
  TOPIC,
  TOPIC_FAQ_ITEM,
  ARTICLE_LIST,
  COMMUNITY,
};



// WEBPACK FOOTER //
// ./home/constants/PropTypesShapes.js